import { createRouter, createWebHistory } from "vue-router";
import MainView from "../views/MainView.vue";
import DashboardView from "../views/DashboardView.vue";
import CostEstimation from "../views/CostEstimationView.vue";
import PurchaseView from "../views/PurchaseView.vue";

import CustomerView from "../views/CustomerView.vue";
import LoginView from "../views/LoginView.vue";
import { useUserStore } from "@/stores/user";
import { useMenuStore } from "@/stores/menu";
import SupplierView from "@/views/SupplierView.vue";
import MaterialMasterView from "@/views/MaterialMasterView.vue";
import MaterialClosingView from "@/views/MaterialClosingView.vue"; // 자재 월마감 (2026-07-15)  // 자재 마스터 (2026-07-15)
import ProfileView from "@/views/ProfileView.vue";
import DesignView from "@/views/DesignView.vue";
import DesignDetailView from "@/views/DesignDetailView.vue";

import ExpenseForm  from "@/components/ExpenseForm.vue";
import ExpenseView from "../views/ExpenseView.vue";
import ExpenseDetailView from "../views/ExpenseDetailView.vue";
import ExpensePrint from "../views/ExpensePrint.vue";

import ExepnseManage from "@/views/ExepnseManage.vue";

import ChangePassword from "@/views/ChangePassword.vue";

import LeaveAdminView from "@/views/LeaveAdminView.vue";
import LeaveAdminBulkView from "@/views/LeaveAdminBulkView.vue";
import LeaveAdminTypesView from "@/views/LeaveAdminTypesView.vue";
import LeaveAdminAuditView from "@/views/LeaveAdminAuditView.vue";
import LeaveAdminRequestsView from "@/views/LeaveAdminRequestsView.vue";
import LeaveRequestView from "@/views/LeaveRequestView.vue"
import CertificateRequestView from "@/views/CertificateRequestView.vue"
import PendingLeavesView from "@/views/PendingLeavesView.vue"
import BirthdayPolicyAdminView from "@/views/birthday/BirthdayPolicyAdminView.vue"
import MyBirthdayView from "@/views/birthday/MyBirthdayView.vue"
import HolidayCalenderView from "@/views/HolidayCalenderView.vue"
import OAuthCallback from "@/views/OAuthCallback.vue";

import Forbidden from "@/views/ForbiddenPage.vue";

import NoticeList from '@/views/NoticeList.vue' ;
import NoticeDetail from '@/views/NoticeDetail.vue' ;
import NoticeEditor from '@/views/NoticeEditor.vue' ;
import NoticeManage from '@/views/NoticeManage.vue' ;

  //
import MaterialOrderList from '@/views/MaterialOrderList.vue'
import MaterialOrderForm from '@/components/MaterialOrderForm.vue';
import MaterialOrderDetail from '@/components/MaterialOrderDetail.vue';
import MaterialOrderManage from '@/components/MaterialOrderManage.vue';
import MaterialOrderPrint from '@/components/MaterialOrderPrint.vue';

//
import MainRequestListView from '@/views/production/MainRequestListView.vue';
import MainRequestDetailView from '@/views/production/MainRequestDetailView.vue';
import ProductionDashboardView from '@/views/production/ProductionDashboardView.vue';
import MaterialDashboardView from '@/views/production/MaterialDashboardView.vue';

//
import MaterialLotListView from '@/views/costing/MaterialLotListView.vue';
import CostCategoryView from '@/views/costing/CostCategoryView.vue';

//
import LCListView from '@/views/trade/LCListView.vue';
import LCDetailView from '@/views/trade/LCDetailView.vue';
import LCRepaymentScheduleView from '@/views/trade/LCRepaymentScheduleView.vue';
import ShipmentListView from '@/views/trade/ShipmentListView.vue';

//
import SampleRequestListView from '@/views/sample/SampleRequestListView.vue';
import SampleRequestDetailView from '@/views/sample/SampleRequestDetailView.vue';
import SampleCostView from '@/views/sample/SampleCostView.vue';
//
import CondolenceListView from '@/views/condolence/CondolenceListView.vue';

//
import QuotationListView from '@/views/estimate/QuotationListView.vue';
import QuotationDetailView from '@/views/estimate/QuotationDetailView.vue';
import QuotationPrintView from '@/views/estimate/QuotationPrintView.vue';

//
import ApprovalInboxView from '@/views/approval/ApprovalInboxView.vue';

//
import ContractListView from '@/views/contract/ContractListView.vue';
import ContractDetailView from '@/views/contract/ContractDetailView.vue';
import MyContractListView from '@/views/contract/MyContractListView.vue';
import MyContractDetailView from '@/views/contract/MyContractDetailView.vue';

const routes = [
  { path: "/", component: DashboardView , meta: { requiresAuth: true } },
  { path: "/ai-assistant", component: () => import('@/views/AiAssistantView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/login", component: LoginView},
  { path: "/oauth/callback", component: OAuthCallback },

  { path: "/profile", component: ProfileView , meta: { requiresAuth: true } },
  { path: "/dashboard", component: DashboardView , meta: { requiresAuth: true } },
  { path: "/calendar", component: MainView , meta: { requiresAuth: true } },
  { path: "/changepassword", component:   ChangePassword    , meta: { requiresAuth: true } },


  
  { path: "/brand-assignments", component: () => import('@/views/BrandAssignmentView.vue'), meta: { requiresAuth: true } },
  { path: "/design-codes", component: () => import('@/views/DesignCodeView.vue'), meta: { requiresAuth: true } },
  // 직원 관리 — 인사·총무 (2026-08-01)
  { path: "/employees-manage", component: () => import('@/views/admin/EmployeeMasterView.vue'), meta: { requiresAuth: true } },
  // 법인 관리 — 기준정보 (2026-08-01, 증명서 발급용 대표자·주소·사업자번호)
  { path: "/companies-manage", component: () => import('@/views/admin/CompanyMasterView.vue'), meta: { requiresAuth: true } },
  // 결재선 관리 — 기준정보 (2026-08-13, 사이먼: "문서별 결재 라인을 볼 수 있는 화면은
  // 없나? 기준정보로 있어야 하지 않나?") — 결재선 템플릿 단계 + 1/2담당자 위임 설정
  { path: "/approval-flow-manage", component: () => import('@/views/admin/ApprovalFlowMasterView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/customer", component: CustomerView , meta: { requiresAuth: true} },
  { path: "/design", component: DesignView , meta: { requiresAuth: true} },
  { path: "/design/:id", name: 'DesignDetail', component: DesignDetailView, meta: { requiresAuth: true } },
  { path: "/supplier", component: SupplierView , meta: { requiresAuth: true  } },   
  { path: "/material-master", component: MaterialMasterView, meta: { requiresAuth: true } },
  { path: "/material-closing", component: MaterialClosingView, meta: { requiresAuth: true } },  // 자재 마스터 (2026-07-15)
  { path: "/costEstimation", component: CostEstimation , meta: { requiresAuth: true } },
  { path: "/purchase", component: PurchaseView , meta: { requiresAuth: true } },
  
  //
  { path: "/material-orders",  component: MaterialOrderList,  meta: { requiresAuth: true }},
  {  path: "/material-orders/new",  component: MaterialOrderForm,  meta: { requiresAuth: true }},
  {  path: "/material-orders/:id",  component: MaterialOrderDetail,  meta: { requiresAuth: true }},
  {  path: "/material-orders/:id/edit",  component: MaterialOrderForm,  meta: { requiresAuth: true }},
  {  path: "/material-orders_manage",  component: MaterialOrderManage,  meta: { requiresAuth: true, role: "isMaterialOrderExecutor" }},
  {  path: "/material-orders/:id/print",  component: MaterialOrderPrint,  meta: { layout: 'print' }},
  

  //
  { path: "/expenses", component: ExpenseView , meta: { requiresAuth: true } },
  { path: "/expenses/vendor-settlement", component: () => import('@/views/expense/VendorSettlementView.vue'), meta: { requiresAuth: true } },
  { path: "/monthly-trade-report", component: () => import('@/views/production/MonthlyTradeReportView.vue'), meta: { requiresAuth: true } },
  { path: "/expenses/:id", component: ExpenseDetailView , meta: { requiresAuth: true }  },
  { path: "/expenses/:id/edit", component: ExpenseForm  , meta: { requiresAuth: true } },
  { path: "/expenses/new", component: ExpenseForm  , meta: { requiresAuth: true } },
  { path: "/expenses_manage", component: ExepnseManage  , meta: { requiresAuth: true,role: "canViewExpenseReport" } },
  { path: "/expense/:id/print",  component: ExpensePrint,  meta: { layout: 'print' }},

  //
  { path: "/leave/admin", redirect: "/leave/admin/quota", meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/admin/quota", component: LeaveAdminView, meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/admin/bulk", component: LeaveAdminBulkView, meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/admin/types", component: LeaveAdminTypesView, meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/admin/requests", component: LeaveAdminRequestsView, meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/admin/audit", component: LeaveAdminAuditView, meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/request", component: LeaveRequestView  , meta: { requiresAuth: true } },
  { path: "/certificate/request", component: CertificateRequestView, meta: { requiresAuth: true } },
  // role: isLeaveManager — 이름은 "휴가관리자"지만 실제 체크는 '인사담당자' 그룹(user.js 주석 참고).
  // isHRManager라는 getter는 store에 없다(다른 라우트가 이미 그 이름으로 쓰고 있는데, 그건 아마
  // 조용히 막혀 있는 기존 버그로 보인다 — 이 라우트에서는 실재하는 getter를 쓴다).
  { path: "/certificate/admin", component: () => import('@/views/admin/CertificateAdminView.vue'), meta: { requiresAuth: true, role: "isLeaveManager" } },
  { path: "/leave/approval", component: PendingLeavesView  , meta: { requiresAuth: true,role:"isLeaveApprover" } },
  { path: "/admin/birthday-policy", component: BirthdayPolicyAdminView, meta: { requiresAuth: true, role: "isHRManager" } },
  { path: "/me/birthday", component: MyBirthdayView, meta: { requiresAuth: true } },
  { path: "/leave/calender", component: HolidayCalenderView  , meta: { requiresAuth: true } },
  
  //
  { path: '/notices',    name: 'NoticeList',    component: NoticeList  },
  { path: '/notices/:id',    name: 'NoticeDetail',    component: NoticeDetail  },
  { path: '/notices/write',    name: 'NoticeEditor',    component: NoticeEditor  },
  { path: '/notices/manage',    name: 'NoticeManage',    component: NoticeManage  },

  //
  { path: "/condolences", component: CondolenceListView, meta: { requiresAuth: true } },

  { path: "/403", component: Forbidden },

  //
  { path: "/production-dashboard", component: ProductionDashboardView, meta: { requiresAuth: true } },
  { path: "/material-dashboard", component: MaterialDashboardView, meta: { requiresAuth: true } },
  { path: "/main-requests", component: MainRequestListView, meta: { requiresAuth: true } },
  { path: "/outsourcing-works", component: () => import('@/views/production/OutsourcingWorkView.vue'), meta: { requiresAuth: true } }, // 외주작업 원장 (2026-07-21)
  { path: "/production-schedule", component: () => import('@/views/production/ProductionScheduleView.vue'), meta: { requiresAuth: true } },
  { path: "/schedule-board", component: () => import('@/views/production/ScheduleBoardView.vue'), meta: { requiresAuth: true } },
  { path: "/factory-portal", component: () => import('@/views/production/FactoryPortalView.vue'), meta: { requiresAuth: true } },
  { path: "/main-requests/:id", component: MainRequestDetailView, meta: { requiresAuth: true } },
  { path: "/production-report", name: 'ProductionReport', component: () => import('@/views/production/MobileReportView.vue'), meta: { requiresAuth: true } },
  { path: "/mobile-receiving", component: () => import('@/views/production/MobileReceivingView.vue'), meta: { requiresAuth: true } },
  { path: "/mobile-packing", component: () => import('@/views/MobilePackingListView.vue'), meta: { requiresAuth: true } },
  { path: "/packing-lists", component: () => import('@/views/PackingListView.vue'), meta: { requiresAuth: true } },
  { path: "/receivings", component: () => import('@/views/ReceivingListView.vue'), meta: { requiresAuth: true } },
  { path: "/material-transfers", component: () => import('@/views/MaterialTransferListView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/inbounds", component: () => import('@/views/production/InboundListView.vue'), meta: { requiresAuth: true } },
  { path: "/outbounds", component: () => import('@/views/production/OutboundListView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/work-instructions/:id", component: () => import('@/views/production/WorkInstructionDetailView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/test-reports", component: () => import('@/views/production/TestReportListView.vue'), meta: { requiresAuth: true } },
  { path: "/milestone-templates", component: () => import('@/views/production/MilestoneTemplateView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/inspections", component: () => import('@/views/InspectionListView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/deliveries", component: () => import('@/views/DeliveryListView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/material-lots", component: MaterialLotListView, meta: { requiresAuth: true, role: "isMaterialOrderManager" } },
  { path: "/cost-categories", component: CostCategoryView, meta: { requiresAuth: true, role: "hasCostAccess" } },
  { path: "/cost-comparison", component: () => import('@/views/costing/CostComparisonView.vue'), meta: { requiresAuth: true, role: "hasCostAccess" } },
  { path: "/executive-dashboard", component: () => import('@/views/ExecutiveDashboardView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/lcs", component: LCListView, meta: { requiresAuth: true } },
  { path: "/lc-repayment-schedule", component: LCRepaymentScheduleView, meta: { requiresAuth: true } },
  { path: "/lcs/:id", component: LCDetailView, meta: { requiresAuth: true } },
  { path: "/shipments", component: ShipmentListView, meta: { requiresAuth: true } },
  { path: "/lgs", component: () => import('@/views/trade/LGListView.vue'), meta: { requiresAuth: true } },
  { path: "/import-invoices", component: () => import('@/views/trade/ImportInvoiceListView.vue'), meta: { requiresAuth: true } },
  // /freight-costs 제거 (2026-07-21, 사이먼 결정): 운임 정본 = 수입송장 부대비 — FreightCost는 레거시(원가 미집계), 기존 데이터는 보존
  { path: "/tt-payments", name: 'TTPaymentList', component: () => import('../views/trade/TTPaymentListView.vue'), meta: { requiresAuth: true } },
  { path: "/debit-notes", name: 'DebitNoteList', component: () => import('../views/trade/DebitNoteListView.vue'), meta: { requiresAuth: true } },
  { path: "/daily-labors", name: 'DailyLaborList', component: () => import('../views/trade/DailyLaborListView.vue'), meta: { requiresAuth: true } },
  // 수출입 통합 관리 (2026-07-12) — 수출신고/부가세유예/수출입 원장
  { path: "/export-declarations", component: () => import('@/views/trade/ExportDeclarationListView.vue'), meta: { requiresAuth: true } },
  { path: "/vat-deferrals", component: () => import('@/views/trade/VatDeferralListView.vue'), meta: { requiresAuth: true } },
  { path: "/trade-ledger", component: () => import('@/views/trade/TradeLedgerView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/sample-requests", component: SampleRequestListView, meta: { requiresAuth: true } },
  { path: "/sample-requests/:id", component: SampleRequestDetailView, meta: { requiresAuth: true } },
  { path: "/sample-costs", component: SampleCostView, meta: { requiresAuth: true } },
  { path: "/season-pipeline", component: () => import('@/views/design/SeasonPipelineView.vue'), meta: { requiresAuth: true } },
  // 디자인실 모바일 스타일 현황 (2026-07-31) — 영업 미팅용 조회 카드
  { path: "/style-status", component: () => import('@/views/design/MobileStyleStatusView.vue'), meta: { requiresAuth: true } },

  //
  { path: "/quotations", component: QuotationListView, meta: { requiresAuth: true, role: "hasQuotationAccess" } },
  { path: "/quotations/:id", component: QuotationDetailView, meta: { requiresAuth: true, role: "hasQuotationAccess" } },
  { path: "/quotations/:id/print", component: QuotationPrintView, meta: { requiresAuth: true, role: "hasQuotationAccess", layout: 'print' } },

  //
  { path: "/approval/inbox", component: ApprovalInboxView, meta: { requiresAuth: true } },

  //
  { path: "/contract", component: ContractListView, meta: { requiresAuth: true } },
  { path: "/contract/:id", component: ContractDetailView, meta: { requiresAuth: true } },

  //
  { path: "/my-contracts", component: MyContractListView, meta: { requiresAuth: true } },
  { path: "/employment-terms", component: () => import('@/views/contract/EmploymentTermsView.vue'), meta: { requiresAuth: true } },
  { path: "/my-contracts/:partyId", component: MyContractDetailView, meta: { requiresAuth: true } },

  //
  { path: "/audit-logs", component: () => import('@/views/AuditLogView.vue'), meta: { requiresAuth: true } },

  // 권한관리 (시스템 관리자 전용)
  { path: "/permission-groups", component: () => import('@/views/admin/PermissionGroupAdminView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/menu-permissions", component: () => import('@/views/admin/MenuPermissionMatrixView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/employee-permissions", component: () => import('@/views/admin/EmployeePermissionView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/menu-access", component: () => import('@/views/admin/MenuAccessView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  { path: "/admin/schedules", component: () => import('@/views/admin/SchedulesView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } }, // 자동 작업 현황 (2026-08-09)
  { path: "/admin/data-load", component: () => import('@/views/admin/DataLoadView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } }, // 데이터 일괄 적재 (2026-08-09)
  { path: "/admin/notification-rules", component: () => import('@/views/admin/NotificationRulesView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } }, // 알림 규칙 관리 (2026-07-20)
  { path: "/admin/integrity-checks", component: () => import('@/views/admin/IntegrityCheckView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } }, // 데이터 정합성 점검 (2026-07-21)

  // 업로드 검토 (엑셀 자동 반영 확인 큐)
  { path: "/upload-reviews", component: () => import('@/views/upload_review/UploadReviewView.vue'), meta: { requiresAuth: true } },

  // 시스템 제보
  { path: "/feedback/mine", component: () => import('@/views/feedback/MyFeedbackView.vue'), meta: { requiresAuth: true } },
  { path: "/feedback/admin", component: () => import('@/views/feedback/FeedbackAdminView.vue'), meta: { requiresAuth: true, role: "isSuperuser" } },
  // 테스트 관리 (qa, 2026-10-18)
  { path: "/qa/my", component: () => import('@/views/qa/MyTestView.vue'), meta: { requiresAuth: true } },
  { path: "/qa/scenarios", component: () => import('@/views/qa/ScenarioManageView.vue'), meta: { requiresAuth: true } },
  { path: "/qa/runs", component: () => import('@/views/qa/RunManageView.vue'), meta: { requiresAuth: true } },

  // 자금일보 / 자금계획 / 대시보드
  { path: "/finance/dashboard", component: () => import('@/views/finance/FinanceDashboardView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/daily-reports", component: () => import('@/views/finance/DailyCashReportListView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/daily-reports/:id", component: () => import('@/views/finance/DailyCashReportDetailView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/payment-plan", component: () => import('@/views/finance/PaymentPlanView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/manual-payments", component: () => import('@/views/finance/ManualPaymentView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/payment-execution", component: () => import('@/views/finance/PaymentExecutionView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/receivable-notes", component: () => import('@/views/finance/ReceivableNoteView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/exchange-rates", component: () => import('@/views/finance/ExchangeRateView.vue'), meta: { requiresAuth: true } },
  { path: "/finance/settings", component: () => import('@/views/finance/FinanceSettingsView.vue'), meta: { requiresAuth: true } },

];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

const CHUNK_RELOAD_FLAG = "smartwork_chunk_reload_attempted";

router.onError((error) => {
  const message = error?.message || "";
  const isChunkLoadError =
    error?.name === "ChunkLoadError" ||
    error?.code === "CSS_CHUNK_LOAD_FAILED" ||
    /Loading (CSS )?chunk [\d]+ failed/i.test(message);

  if (!isChunkLoadError) return;

  const alreadyReloaded = sessionStorage.getItem(CHUNK_RELOAD_FLAG) === "1";
  if (alreadyReloaded) {
    sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
    console.error("Chunk load failed after retry reload:", error);
    return;
  }

  sessionStorage.setItem(CHUNK_RELOAD_FLAG, "1");
  window.location.reload();
});

router.afterEach(() => {
  sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
});


router.beforeEach(async (to, from, next) => {
  const userStore = useUserStore();
  const menuStore = useMenuStore();

  const token = localStorage.getItem("access_token");
  if (token && !userStore.isAuthenticated) {
    await userStore.fetchUserProfile();
  }

  if (to.meta.requiresAuth && !userStore.isAuthenticated) {
    next("/login");
    return;
  }

  // ✅ 메뉴 노출 권한 선로드 (첫 렌더 전에 준비 → 빈 메뉴 깜빡임 방지)
  if (userStore.isAuthenticated && !menuStore.loaded) {
    await menuStore.fetchMyMenus();
  }



    if (to.meta.role && !userStore[to.meta.role]) {
      return next("/403");
    }

  // ✅ 시작 화면 설정: 앱 최초 진입(새로고침/PWA 실행)이 '/'이면 1회만 리다이렉트.
  //    경영 대시보드 화면의 "시작 화면으로 설정" 토글로 켜고 끔 (기기별 localStorage).
  //    이후 로고/홈 클릭으로 '/'에 가는 것은 정상 동작 (from이 존재하므로 미적용).
  if (
    to.path === "/" &&
    from.matched.length === 0 &&
    userStore.isAuthenticated &&
    localStorage.getItem("start_screen") === "executive-dashboard" &&
    menuStore.canSee("executive-dashboard")
  ) {
    return next("/executive-dashboard");
  }

  next();
});

export default router;